<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a general modal to be on the page and used when needed
    *
    * @since 20230831
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2023 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div class="modal fade" id="main_general_modal" role="dialog">
        <div :class="['modal-dialog', modalSizeClass]">       
            <!-- Modal content-->
            <div class="modal-content">
                <div v-if="title.length > 0" class="modal-header">
                    <h4 class="modal-title" v-html="title"></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body" v-html="text">
                    
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal"><i v-if="closeButtonIcon.length > 0" :class="['fa', closeButtonIcon, 'pr-1']"></i>{{closeButtonText}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
        },
        created() {
            this.$wexModal = this;
        },
        data() {
            return {
                title: '',
                text: '',
                closeButtonText: 'OK',
                closeButtonIcon: '',
                modalSizeClass: '',
            }
        },
        computed: {
        },
        methods: {
            /**
             * shows the insurance modal
             * 
             * @param Object insurance the insurance to display on the modal
             */
            showModal: function(text='', options={}){
                this.text = text;
                var fieldsToGet = {
                    title: '',
                    closeButtonText: 'OK',
                    closeButtonIcon: '',
                    modalSizeClass: ''
                };
                if(options !== null){
                    for (const key in fieldsToGet) {
                        if (fieldsToGet.hasOwnProperty(key)) {
                            this[key] = options[key] !== undefined && options[key] !== null ? options[key] : fieldsToGet[key];
                        }
                    }
                }
                this.title = options.title !== undefined && options.title !== null ? options.title : '';
                $('#main_general_modal').modal('show');
            },
        }
    }
</script>